function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 23h18.586L64 44.414V74H24V23z",
  stroke: "#97A2C8",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23 19a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v1H23v-1z",
  fill: "#97A2C8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("mask", {
  id: "image-placeholder_svg__a",
  fill: "#fff"
}, React.createElement("rect", {
  x: 25,
  y: 12,
  width: 16,
  height: 8,
  rx: 1
}));

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 25,
  y: 12,
  width: 16,
  height: 8,
  rx: 1,
  stroke: "#97A2C8",
  strokeWidth: 4,
  mask: "url(#image-placeholder_svg__a)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51 56a7 7 0 1 1-14 0c0-1.287.433-2.692 1.144-4.115.709-1.417 1.664-2.794 2.637-4.01A36.794 36.794 0 0 1 44 44.363a36.794 36.794 0 0 1 3.22 3.512c.972 1.216 1.927 2.593 2.636 4.01C50.567 53.308 51 54.713 51 56z",
  stroke: "#97A2C8",
  strokeWidth: 2
});

const SvgImagePlaceholder = props => React.createElement("svg", _extends({
  viewBox: "0 0 88 88",
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4, _ref5);

export default SvgImagePlaceholder;